module.exports = __webpack_public_path__ + "media/images/lb/674-b77a23b452d490f74dcf7d3885666872.svg";